
import React from 'react';
import { Link } from 'react-router-dom';

interface NavigationItemProps {
  to: string;
  currentPath: string;
  exactMatch?: boolean;
  children: React.ReactNode;
}

const NavigationItem = ({ to, currentPath, exactMatch = false, children }: NavigationItemProps) => {
  // More flexible matching - exact match or starts with path
  // Special handling for KPI detail pages
  const isActive = exactMatch 
    ? currentPath === to
    : currentPath === to || 
      (to !== '/' && currentPath.startsWith(to)) ||
      (to.includes('/top-kpis') && currentPath.includes('/kpi/'));

  return (
    <Link
      to={to}
      className={`text-sm font-medium transition-colors ${
        isActive 
          ? "text-blue-600" 
          : "text-black hover:text-blue-600 dark:text-gray-200"
      }`}
    >
      {children}
    </Link>
  );
};

export default NavigationItem;
